import { FC } from 'react';
import { CareMapDrawerPage } from '../components/CareMapDrawerPage';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { ActivePatientView } from './ActivePatientView';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { NEW_ALLERGY_ID, NEW_DIAGNOSIS_ID, NEW_MEDICATION_ID } from '../caremap/ICareMap';

export const PatientDrawerView: FC = () => {
    const careMapState = useInstance(CareMapState);
    const history = useInstance(HistoryViewModel);

    useSubscription(() => careMapState);

    const caremap = careMapState.getActiveCaremap();

    const patient = caremap?.patient;

    // don't love duplicating this, but without it, we are creating an empty drawer
    // so easier to assume this was here for good reason, and duplicate it
    if (!caremap || !patient) {
        return null;
    }

    const openEditPatientDrawer = () => {
        history.push(`/caremaps/${careMapState.getActiveCaremap()?.careMapId}/drawer/household/member/patient/edit`);
    };

    const editMedication = (id: string) => {
        history.push(`/caremaps/${careMapState.getActiveCaremap()?.careMapId}/drawer/household/member/patient/medications/${id}`);
    };

    const editAllergy = (id: string) => {
        history.push(`/caremaps/${careMapState.getActiveCaremap()?.careMapId}/drawer/household/member/patient/allergies/${id}`);
    };

    const editDiagnosis = (id: string) => {
        history.push(`/caremaps/${careMapState.getActiveCaremap()?.careMapId}/drawer/household/member/patient/diagnoses/${id}`);
    };

    return (
        <CareMapDrawerPage title="Care Recipient Detail" hasBack={true}>
            <ActivePatientView
                excludeDOBInNudge
                onEdit={openEditPatientDrawer}
                onMedicationClick={editMedication}
                onAddMedication={() => editMedication(NEW_MEDICATION_ID)}
                onAllergyClick={editAllergy}
                onAddAllergy={() => editAllergy(NEW_ALLERGY_ID)}
                onDiagnosisClick={editDiagnosis}
                onAddDiagnosis={() => editDiagnosis(NEW_DIAGNOSIS_ID)}
            />
        </CareMapDrawerPage>
    );
};
